import { devToolsExtension, isBrowser } from "@client/lib/misc";
import { type GetMiddlewaresArgs } from "@client/types";
import { applyMiddleware, compose, createStore } from "redux";
import { thunk } from "redux-thunk";
import dynamicReducersMiddleware from "./middleware/dynamicReducers";
import loaderMiddleware from "./middleware/loader";
import { createReducer } from "./reducers";
import { type ViewerAppState } from "./types";

export const getMiddlewares = (args: GetMiddlewaresArgs<any>) => {
  const result = [thunk, dynamicReducersMiddleware];

  if (isBrowser()) {
    result.push(...[loaderMiddleware()]);
  }

  return result;
};

export default function configureStore(initialState: Partial<ViewerAppState>) {
  const args: GetMiddlewaresArgs<ViewerAppState> = {
    getStore: () => store,
    createReducer
  };

  const finalCreateStore = compose(applyMiddleware(thunk, ...getMiddlewares(args)), devToolsExtension)(createStore);

  const store = finalCreateStore(createReducer(), initialState) as any;

  if (module["hot"]) {
    module["hot"].accept("./reducers", () => {
      const createNextReducer = require("./reducers").default;
      store.replaceReducer(createNextReducer(store.dynamicReducers));
    });
  }

  return store;
}
